export default __webpack_public_path__ + "static/media/pictogramBeaconCategories128.29d91982.svg";